import { ReactElement } from 'react';
import {
  linkedinBlack,
  twitterBlack,
  instagramBlack,
  tiktokBlack,
  youtubeBlack,
} from '../../assets';

const socialLinks = [
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/weflenjor/',
    icon: linkedinBlack,
  },
  {
    name: 'Twitter',
    href: 'https://twitter.com/weflenjor',
    icon: twitterBlack,
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/weflenjor/',
    icon: instagramBlack,
  },
  { name: 'TikTok', href: 'https://tiktok.com/@weflenjor', icon: tiktokBlack },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/channel/UC-W5ptrkKLG9a2w9KrEuwww?sub_confirmation=1',
    icon: youtubeBlack,
  },
];

function Footer(): ReactElement {
  return (
    <nav className="container footer" aria-label="Social media">
      <div className="centered_content footer_content">
        {socialLinks.map(({ name, href, icon }) => (
          <a
            key={name}
            target="_blank"
            rel="noreferrer noopener"
            href={href}
            aria-label={`Flenjor on ${name}`}
          >
            <img src={icon} alt={name} />
          </a>
        ))}
      </div>
    </nav>
  );
}

export default Footer;
